import { Component, effect, Inject, input, output, signal } from '@angular/core';
import { JSBridgeService } from '../jsbridge.service';
import { ServerAPI } from '../../serverapi';
import { downloadData, removePrinterChars, uint8ArrayToString } from '../../utils/utils';
import { LegacyListService } from '../../legacy-list.service';

@Component({
  selector: 'legacy-list',
  templateUrl: './legacy-list.component.html',
  styleUrl: './legacy-list.component.scss'
})
export class LegacyListComponent {

  constructor(public jsBridgeService: JSBridgeService, @Inject('ServerApi') private serverApi: ServerAPI, private legacyListService: LegacyListService) {

    effect(() => {
      if (this.isEditing()) {
        this.list = "...";
        this.dbl = "...";
        this.generateList();
      }
    });
  }

  public async generateList() {
    this.jsBridgeService.getBridgeSync().save();
    let ret = await this.jsBridgeService.generateKopList();
    let klantNo = this.jsBridgeService.getKlantNo();
    if (ret != undefined && klantNo != undefined) {
      let listName = `/working/LST/${klantNo}.LST`;
      if (ret[listName] != undefined) {
        this.list = removePrinterChars(uint8ArrayToString(ret[listName]));//new TextDecoder().decode(ret[listName] as Uint8Array);
      }
      let dblName = `/working/LST/${klantNo}.DBL`;
      if (ret[dblName] != undefined) {
        this.dbl = removePrinterChars(uint8ArrayToString(ret[dblName]));//new TextDecoder().decode(ret[dblName] as any);
      }
    }
  }

  public isEditing = input<boolean>(false);
  public onDone = output<boolean>();

  public list = "...";
  public dbl = "...";

  public downloadList() {
    downloadData(new TextEncoder().encode(this.list), `${this.jsBridgeService.getKlantNo()}.LST`);
  }

  public openList() {
    let url = new URL("/VIEWER", window.location.origin);
    window.localStorage.setItem("list", this.list);
    url.searchParams.set("text", "list");
    window.open(url.toString(), "_blank");
  }

  public downloadDbl() {
    downloadData(new TextEncoder().encode(this.dbl), `${this.jsBridgeService.getKlantNo()}.DBL`);
  }

  public openDbl() {
    let url = new URL("/VIEWER", window.location.origin);
    window.localStorage.setItem("dbl", this.dbl);
    url.searchParams.set("text", "dbl");
    window.open(url.toString(), "_blank");
  }

}
